import {DataFetcher} from '@aboutyou/data-fetcher';
import {Grid, PlaceholderTiles} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {StreamPaddingCSS} from '../../../features/ProductStream/helpers';
import {useSimilarProducts} from '../hooks/useSimilarProducts';
import {SimilarProductsEmpty} from './SimilarProductsEmpty';
import {
  SimilarProductsStreamView,
  SimilarProductsStreamViewProps,
} from './SimilarProductsStreamView';

export const SimilarProductsStream = (
  props: SimilarProductsStreamViewProps,
) => {
  return (
    <SimilarProductsItemGrid compact={!!props.compact}>
      <DataFetcher
        request={useSimilarProducts()}
        Loading={() => <PlaceholderTiles amount={24} />}
        View={SimilarProductsStreamView}
        viewProps={props}
        Error={SimilarProductsEmpty}
      />
    </SimilarProductsItemGrid>
  );
};

const SimilarProductsItemGrid: React.FC<
  React.PropsWithChildren<{compact: boolean}>
> = ({children, compact}) => {
  return (
    <section>
      <StyledContainer $compact={compact}>
        <StyledGrid
          uniqueKey="similarProductsPage"
          enableEnhancedTileRendering
          $compact={compact}
        >
          {children}
        </StyledGrid>
      </StyledContainer>
    </section>
  );
};
const StyledContainer = styled.div<{$compact: boolean}>`
  margin-left: ${({$compact}) => ($compact ? '10%' : '0')};
  margin-right: ${({$compact}) => ($compact ? '10%' : '0')};
`;

const StyledGrid = styled(Grid)<{$compact: boolean}>`
  ${({$compact}) => !$compact && StreamPaddingCSS}
`;
